export interface UserProfileMenuItem {
  type: 'navItem' | 'divider'
  icon?: string
  title?: string
  to?: Record<string, any>
  href?: string
  onClick?: () => void
}

export interface UserProfileMenuOptions {
  hasMultipleProviders: boolean
  onLogout: () => void
}

/**
 * Builds the UserProfile.vue user-menu dropdown items. Split out from the component
 * so item visibility (Switch Provider) is unit-testable without
 * mounting a component — this repo's Vitest setup (see vitest.config.ts) doesn't
 * pull in @vue/test-utils or a DOM environment.
 */
export function buildUserProfileList(options: UserProfileMenuOptions): UserProfileMenuItem[] {
  const { hasMultipleProviders, onLogout } = options

  // Provider Settings moved out of this menu into the provider sidebar's Reporting group
  // (VH-3450, src/navigation/provider.ts).
  const list: UserProfileMenuItem[] = [
    { type: 'navItem', icon: 'mdi-account-outline ', title: 'Profile Settings', to: { name: 'profile-settings' } },
  ]

  // Only providers users assigned to more than one provider organization have
  // anything to switch between.
  if (hasMultipleProviders) {
    list.push({ type: 'divider' })
    list.push({ type: 'navItem', icon: 'mdi-swap-horizontal', title: 'Switch Provider', to: { name: 'dashboard-select-provider' } })
  }

  list.push({ type: 'divider' })
  list.push({ type: 'navItem', icon: 'mdi-help-circle-outline', title: 'Support', href: 'mailto:support@vectorhealth.ai' })
  list.push({ type: 'divider' })
  list.push({ type: 'navItem', icon: 'mdi-logout', title: 'Logout', onClick: onLogout })

  return list
}
